/**
 * Hospital Switcher + Branch Switcher (STEP 5). Reads
 * `store/hospital.store.ts`/`store/branch.store.ts` — real state
 * management. Stage F5 wires the actual `GET /hospitals`/`GET
 * /branches` selection UI (`SwitchBranchDialog`, `features/dashboard/`)
 * for the first time, closing the gap this component's own F0 header
 * comment explicitly deferred ("that wiring is Stage F1+'s own job,
 * once a real page needs it").
 */
import { useState, type JSX } from 'react';
import { Button, Typography } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useHospitalStore } from '@store/hospital.store';
import { useBranchStore } from '@store/branch.store';
import { SwitchBranchDialog } from '@features/dashboard/components/SwitchBranchDialog';

export function HospitalBranchSwitcher(): JSX.Element {
  const currentHospital = useHospitalStore((state) => state.currentHospital);
  const currentBranch = useBranchStore((state) => state.currentBranch);
  const [dialogOpen, setDialogOpen] = useState(false);

  const label = currentHospital
    ? `${currentHospital.displayName}${currentBranch ? ` · ${currentBranch.name}` : ''}`
    : 'Select hospital';

  return (
    <>
      <Button
        size="small"
        color="inherit"
        startIcon={<ApartmentIcon fontSize="small" />}
        sx={{ textTransform: 'none', maxWidth: 240 }}
        onClick={() => setDialogOpen(true)}
      >
        <Typography variant="body2" noWrap>
          {label}
        </Typography>
      </Button>
      <SwitchBranchDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
}
